<template>
  <div id="app" :class="theme + '-theme'">

    <Menu 
      v-on:tab_selected="onTabSelected" 
      :theme="theme" 
      :selected_tab="current_tab_selection"
      v-on:toggle-theme="toggleTheme"
    />

    <Content :selected_tab="current_tab_selection"/>
    
  </div>
</template>

<script>

import Menu from './components/Menu.vue'
import Content from './components/Content.vue'

export default {
  name: 'app',
  components: {
    Menu,
    Content
  },
  data: function(){
    return {
      current_tab_selection : '1',
      theme: localStorage.getItem('theme') || 'light'
    }
  },
  methods: {
    onTabSelected: function(tabVal){
      this.current_tab_selection = tabVal;
    },
    toggleTheme: function() {
      this.theme = this.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', this.theme);
    }
  },
  mounted: function(){
    this.current_tab_selection = '2';
    // Initialize theme
    document.body.style.backgroundColor = 'var(--bg-color)';
  },
  watch: {
    theme: {
      immediate: true,
      handler(newTheme) {
        document.documentElement.setAttribute('data-theme', newTheme);
      }
    }
  }
}
</script>

<style>
:root {
  --bg-color: #ffffff;
  --text-color: #555555;
  --heading-color: #222222;
  --link-color: #0066cc;
  --icon-filter: none;
  --hover-bg: rgba(0, 0, 0, 0.05);
  --modal-bg: rgba(0, 0, 0, 0.8);
  --card-bg: #ffffff;
}

[data-theme='dark'] {
  --bg-color: #121212;
  --text-color: #b0b0b0;
  --heading-color: #e0e0e0;
  --link-color: #4a9eff;
  --icon-filter: invert(1);
  --hover-bg: rgba(255, 255, 255, 0.05);
  --modal-bg: rgba(0, 0, 0, 0.9);
  --card-bg: #1e1e1e;
}

#app {
  font-family: 'Nunito Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
  background-color: var(--bg-color);
  min-height: 100vh;
  display: flex;
  transition: background-color 0.3s ease, color 0.3s ease;
}

@media screen and (max-width: 600px) {
  #app {
    flex-direction: column;
  }
}

* {
  box-sizing: border-box;
}

body {
  background-color: var(--bg-color);
  margin: 0;
}

/* Style the body */
body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td, hr, button, article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    margin: 0;
    padding: 0;
}

ul, ol {
    list-style: none;
}
p{
  font-size: 16px;
}

.heading {
  color: var(--heading-color);
}

a {
  color: var(--link-color);
}
</style>
